import { NgModule } from '@angular/core';
import { SwiperSlideDirective } from './swiper-slide.directive';
import { SwiperComponent } from './swiper.component';
import { SwiperDirective } from './swiper.directive';

/**
 * Convenience const for standalone components — spread it into a component's `imports`
 * array to pull in the whole card family in one line:
 *
 * ```ts
 * @Component({
 *     imports: [...SWIPER_DIRECTIVES],
 *     // ...
 * })
 * ```
 */
export const SWIPER_DIRECTIVES = [SwiperDirective, SwiperSlideDirective, SwiperComponent] as const;

@NgModule({
  imports: [...SWIPER_DIRECTIVES],
  exports: [...SWIPER_DIRECTIVES],
})
export class SwiperModule {}
